<template>
  <Wrapper
    id="wrapper-floatframe"
    :position="floatFrameActive.position"
    :widgetHeaderActive="widgetHeaderActive"
    v-if="!preview && renderTools && floatFrameActive.id"
  >
    <FloatframeActive  
      :headerActive="headerActive"
      id="floatframe-header-active" 
      :class="{'disabled': widgetHeaderActive}"
    >
      {{ $t(`engine.floatframeTool.floatframeActive.${floatFrameActive.name.toUpperCase()}`,languageEngine) }}
    </FloatframeActive>
  </Wrapper>
</template>
<script>
import {
  FloatframeActive,
  Wrapper
} from "./FloatFrameActive.styled";
import { mapGetters } from "vuex";

export default {
  components: {
    FloatframeActive,
    Wrapper,
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      floatFrameActive: "designIframe/frame/floatFrameActive",
      widgetActive: "designIframe/frame/widgetActive",
      siteComponents: "designIframe/metadata/siteComponents",
      languageEngine: "designIframe/userPreference/languageEngine",
    }),
    headerActive() {
      return this.floatFrameActive.id && this.floatFrameActive.id.includes("HEADER") ? true : false
    },
    widgetHeaderActive() {
      return  this.widgetActive.id && this.widgetActive.id.includes("HEADER_WIDGET") || 
              this.widgetActive.id && this.widgetActive.id.includes("FOOTER_WIDGET") ? true : false
    },
  },
  methods:{}
};
</script>
